import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface Sale {
  name: string;
  location: string;
  price: number;
}
export function SalesNotification() {
  const [currentSale, setCurrentSale] = useState<Sale | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const indexRef = useRef(0);
  const sales: Sale[] = [{
    name: 'Sarah',
    location: 'Miami, FL',
    price: 0
  }, {
    name: 'Michael',
    location: 'Los Angeles, CA',
    price: 0
  }, {
    name: 'Jessica',
    location: 'New York, NY',
    price: 0
  }, {
    name: 'David',
    location: 'Houston, TX',
    price: 0
  }, {
    name: 'Emily',
    location: 'Phoenix, AZ',
    price: 0
  }, {
    name: 'Daniel',
    location: 'Chicago, IL',
    price: 0
  }, {
    name: 'Ashley',
    location: 'Seattle, WA',
    price: 0
  }, {
    name: 'Christopher',
    location: 'Boston, MA',
    price: 0
  }, {
    name: 'Amanda',
    location: 'Denver, CO',
    price: 0
  }, {
    name: 'Matthew',
    location: 'Atlanta, GA',
    price: 0
  }, {
    name: 'Jennifer',
    location: 'Portland, OR',
    price: 0
  }, {
    name: 'Joshua',
    location: 'Austin, TX',
    price: 0
  }, {
    name: 'Andrew',
    location: 'San Diego, CA',
    price: 0
  }, {
    name: 'Elizabeth',
    location: 'Dallas, TX',
    price: 0
  }, {
    name: 'James',
    location: 'San Jose, CA',
    price: 0
  }, {
    name: 'Megan',
    location: 'Las Vegas, NV',
    price: 0
  }, {
    name: 'Robert',
    location: 'Nashville, TN',
    price: 0
  }, {
    name: 'Lauren',
    location: 'Orlando, FL',
    price: 0
  }, {
    name: 'William',
    location: 'Charlotte, NC',
    price: 0
  }, {
    name: 'Rachel',
    location: 'San Francisco, CA',
    price: 0
  }, {
    name: 'Joseph',
    location: 'Indianapolis, IN',
    price: 0
  }, {
    name: 'Samantha',
    location: 'Columbus, OH',
    price: 0
  }, {
    name: 'Ryan',
    location: 'Fort Worth, TX',
    price: 0
  }, {
    name: 'Nicole',
    location: 'Detroit, MI',
    price: 0
  }, {
    name: 'Brandon',
    location: 'El Paso, TX',
    price: 0
  }, {
    name: 'Kayla',
    location: 'Memphis, TN',
    price: 0
  }, {
    name: 'Justin',
    location: 'Baltimore, MD',
    price: 0
  }, {
    name: 'Hannah',
    location: 'Milwaukee, WI',
    price: 0
  }, {
    name: 'Anthony',
    location: 'Albuquerque, NM',
    price: 0
  }, {
    name: 'Stephanie',
    location: 'Tucson, AZ',
    price: 0
  }];
  const prices = [24.99, 69.99, 79.99];
  const delaySequence = [4000, 10000, 18000, 14000, 10000, 4000, 13000, 10000];
  useEffect(() => {
    function showNotification() {
      const randomSale = sales[Math.floor(Math.random() * sales.length)];
      const randomPrice = prices[Math.floor(Math.random() * prices.length)];
      setCurrentSale({
        ...randomSale,
        price: randomPrice
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 3000);
    }
    function triggerSaleNotification() {
      showNotification();
      const delay = delaySequence[indexRef.current];
      indexRef.current = (indexRef.current + 1) % delaySequence.length;
      setTimeout(triggerSaleNotification, delay);
    }
    triggerSaleNotification();
  }, []);
  return <AnimatePresence data-id="element-331">
      {isVisible && currentSale && <motion.div initial={{
      opacity: 0,
      y: 100,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 100,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed bottom-6 left-4 right-4 md:left-6 md:right-auto md:max-w-sm z-50" data-id="element-332">
          <motion.div initial={{
        y: 10
      }} animate={{
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} className="bg-[#0C0A09]/95 backdrop-blur-xl rounded-2xl shadow-2xl p-4 flex items-center gap-3 border border-[#CFA86A]/30" style={{
        boxShadow: '0 10px 40px rgba(207, 168, 106, 0.2)'
      }} data-id="element-333">
            {/* Product Image */}
            <div className="flex-shrink-0" data-id="element-334">
              <img src="https://cdn.magicpatterns.com/uploads/ijjTYGfFS1MmmQdLLPGFhC/ChatGPT_Image_Dec_4,_2025,_12_32_32_AM.png" alt="Product" className="w-20 h-20 rounded-lg object-cover border border-[#CFA86A]/20" data-id="element-335" />
            </div>

            {/* Sale Info */}
            <div className="flex-1 min-w-0" data-id="element-336">
              <p className="text-sm font-semibold text-[#F7F5F2] truncate" data-id="element-337">
                {currentSale.name} from {currentSale.location}
              </p>
              <p className="text-xs text-[#F7F5F2]/70 mt-0.5" data-id="element-338">
                just purchased{' '}
                <span className="font-medium text-[#F7F5F2]" data-id="element-339">
                  Decisiones Que Cambian Tu Vida
                </span>
              </p>
              <p className="text-sm font-bold text-[#CFA86A] mt-1" data-id="element-340">
                ${currentSale.price.toFixed(2)}
              </p>
            </div>

            {/* Pulse indicator */}
            <div className="flex-shrink-0" data-id="element-341">
              <motion.div animate={{
            scale: [1, 1.2, 1],
            opacity: [0.5, 1, 0.5]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="w-2 h-2 rounded-full bg-[#CFA86A]" data-id="element-342" />
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}